var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNight = function SvgIconNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.273 12.379a.462.462 0 0 0-.509-.14 4.87 4.87 0 0 1-1.635.271c-2.77 0-5.024-2.221-5.024-4.95 0-1.643.823-3.172 2.201-4.091a.451.451 0 0 0 .19-.474.456.456 0 0 0-.38-.344 4.446 4.446 0 0 0-.64-.041c-3.778 0-6.851 3.028-6.851 6.75s3.073 6.75 6.85 6.75c2.398 0 4.579-1.2 5.833-3.211a.447.447 0 0 0-.035-.52z",
    fill: "#7B1FA1",
    fillRule: "evenodd"
  })));
};
export default SvgIconNight;